import React from 'react';
import { cn } from '../../../lib/cn';

/**
 * Tag, the small tertiary pill for rarity and condition metadata.
 *
 * CSS selector: `mobile/atoms.css` `.ds-tag` (+ `--rarity`, `--abbrev`,
 * `--outline`).
 *
 * Doctrine: metadata is the smallest and quietest text in any card, so a tag
 * never competes with the title or the price. It is purely presentational and
 * renders a span, never a button. If it needs to be tappable it is a `<Chip>`,
 * not a tag.
 */
const TAG_VARIANT = {
  default: null,
  rarity: 'ds-tag--rarity',
  abbrev: 'ds-tag--abbrev',
  outline: 'ds-tag--outline',
};

export const Tag = React.forwardRef(function Tag({ className, variant = 'default', ...rest }, ref) {
  return <span ref={ref} className={cn('ds-tag', TAG_VARIANT[variant], className)} {...rest} />;
});

export default Tag;
